import Api from '../../../services/Api'

export const getProductLimitData = (url: string, filters: any) => {
  return Api.get(`${url}`, filters, {}).then((d: any) => {
    return d.data
  })
}
